export const ChatMessage = {
  flow: 'x',
  gap: 'Z',
  padding: 'Z A',
  align: 'flex-start flex-start',
  borderLeft: (el, s) => {
    const urgency = s.urgency || 'normal'
    if (urgency === 'urgent') return '3px solid red'
    if (urgency === 'important') return '3px solid amber'
    return '3px solid transparent'
  },
  background: (el, s) => {
    const urgency = s.urgency || 'normal'
    if (urgency === 'urgent') return 'red.05'
    if (urgency === 'important') return 'amber.05'
    return 'transparent'
  },
  ':hover': { background: 'inkMid' },
  transition: 'background 150ms ease',

  Avatar: {
    width: 'C',
    height: 'C',
    minWidth: 'C',
    round: 'C',
    background: (el, s) => s.avatarColor || 'teal.15',
    color: (el, s) => s.avatarTextColor || 'teal',
    display: 'flex',
    align: 'center center',
    fontSize: 'Z',
    fontWeight: '700',
    text: (el, s) => s.initials || '??'
  },

  Content: {
    flow: 'y',
    gap: 'W',
    flex: '1',

    Header: {
      flow: 'x',
      gap: 'Y',
      align: 'center flex-start',
      SenderName: { text: (el, s) => s.sender || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
      Timestamp: { text: (el, s) => s.timestamp || '', fontSize: 'Y', color: 'inkMuted' },
      UrgencyTag: {
        show: (el, s) => s.urgency && s.urgency !== 'normal',
        text: (el, s) => s.urgency === 'urgent' ? '{{ urgent | polyglot }}' : '{{ important | polyglot }}',
        fontSize: 'Y',
        fontWeight: '600',
        padding: 'W Y',
        round: 'Y',
        background: (el, s) => s.urgency === 'urgent' ? 'red.15' : 'amber.15',
        color: (el, s) => s.urgency === 'urgent' ? 'red' : 'amber'
      }
    },

    MessageText: {
      text: (el, s) => s.text || '',
      fontSize: 'Z',
      color: 'inkText',
      lineHeight: '1.5'
    },

    StatusIndicator: {
      show: (el, s) => !!s.status,
      flow: 'x',
      gap: 'W',
      align: 'center flex-start',
      StatusIcon: {
        fontSize: 'Y',
        color: (el, s) => s.status === 'read' ? 'teal' : 'inkMuted',
        text: (el, s) => {
          if (s.status === 'sent') return '\u2713'
          if (s.status === 'delivered') return '\u2713\u2713'
          if (s.status === 'read') return '\u2713\u2713'
          return ''
        }
      },
      StatusLabel: {
        fontSize: 'Y',
        color: (el, s) => s.status === 'read' ? 'teal' : 'inkMuted',
        text: (el, s) => {
          if (s.status === 'sent') return '{{ sent | polyglot }}'
          if (s.status === 'delivered') return '{{ delivered | polyglot }}'
          if (s.status === 'read') return '{{ read | polyglot }}'
          return ''
        }
      }
    }
  }
}
